import React from 'react';

import RenderIfVisible from 'react-render-if-visible'

import Sheet from "@mui/joy/Sheet";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";
import AccordionDetails, { accordionDetailsClasses } from '@mui/joy/AccordionDetails';
import {Accordion, AccordionGroup, AccordionSummary, CardOverflow, CircularProgress, Stack} from "@mui/joy";
import Chip from "@mui/joy/Chip";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";

// components
import BaseApi from "../../utils/BaseApi";
import CommentSidebar from "../Comment/CommentSidebar";
import OpportunityCard from "../Cards/OpportunityCard";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import ComponentCard from "../Common/ComponentCard";
import CommentReadAll from "../Comment/CommentReadAll";
import DeliveryTable from "../Delivery/DeliveryTable";
import RouteTable from "../Route/RouteTable";
import NotificationDetailModal from "../Notification/NotificationDetailModal";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import retrievePermission from "../../utils/retrievePermission";
import AccountCard from "../Cards/AccountCard";

// icons
import StarIcon from '@mui/icons-material/Star';
import VisibilityIcon from "@mui/icons-material/Visibility";
import showdown from "showdown";


class OpportunityCommentCenter extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            opportunities: null,
            opportunitiesFeatured: null,
            opportunity: null,
            mode: 'Opportunity',
            deliveryStates: null,
            opportunityDeliveryStates: [],
            routeStates: null,
            notifications: null,
            unreadComments: null,
            leads: null,
            leadPermission: 0,
        }
    }

    async componentDidMount() {
        await this.retrieveOpportunities();
        await this.retrieveDeliveryStates();
        await this.retrieveRouteStates();
        await this.retrieveNotifications();
        await this.retrieveMessageCount();
        await this.retrieveLeadPermission();
        await this.retrieveLeads();
        this.timer = setInterval(
            this.retrieveMessageCount.bind(this),
            10000
        );
        this.notificationTimer = setInterval(
            this.retrieveNotifications.bind(this),
            10000
        );
        this.deliveryTimer = setInterval(
            this.retrieveDeliveryStates.bind(this),
            10000
        );
        this.routeTimer = setInterval(
            this.retrieveRouteStates.bind(this),
            10000
        );
        this.leadTimer = setInterval(
            this.retrieveLeads.bind(this),
            10000
        );
    }

    componentWillUnmount() {
        if (this.timer){
            clearInterval(this.timer);
        }
        if (this.notificationTimer){
            clearInterval(this.notificationTimer);
        }
        if (this.deliveryTimer){
            clearInterval(this.deliveryTimer);
        }
        if (this.routeTimer){
            clearInterval(this.routeTimer);
        }
        if (this.leadTimer){
            clearInterval(this.leadTimer);
        }
    }

    async notificationsReadAll(){
        const api = new BaseApi();
        let url = 'notification/read_all';
        await api.get(url, {});
        await this.retrieveNotifications();
    }

    async feature(id) {
        const url = `opportunity/${id}/feature/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        if (response.status === 200){
            await this.retrieveOpportunities()
        }
    }

    setOpportunity(opportunity, deliveryStates, color){
        this.setState(
            {
                opportunity: null,
                opportunityColor: null,
                opportunityDeliveryStates: [],
            }
        )
        this.setState(
            {
                mode: 'Opportunity',
                opportunity: opportunity,
                opportunityColor: color,
                opportunityDeliveryStates: deliveryStates,
            }
        )
    }

    setMode(mode){
        this.setState(
            {
                mode: null,
            }
        )
        this.setState(
            {
                mode: mode,
            }
        )
    }

    async retrieveLeadPermission() {
        let p = await retrievePermission(
            'LeadViewSet',
            'list',
            this.context.subscriberObject
        );
        this.setState(
            {
                leadPermission: p
            }
        );
    }

    async retrieveLeads() {
        const url = 'lead/';
        const api = new BaseApi();
        let params = {
            xtype: 'incoming',
            page_size: 10000,
            status: 'OPEN',
        }
        let response = await api.get(url, params);
        this.setState(
            {
                leads: response.data.results,
            }
        );
    }

    async retrieveDeliveryStates(){
        const url = 'delivery_state/my/';
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                deliveryStates: response.data.results
            }
        );
    }

    async retrieveRouteStates(){
        const url = 'route_state/my/';
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                routeStates: response.data.results
            }
        );
    }

    async retrieveNotifications(id) {
        const api = new BaseApi();
        let url
        if (id) {
            url = `notification/${id}/`;
            await api.patch(
                url,
                {is_read: true},
            );
        }
        url = 'notification/';
        let params = {
            page_size: 10000,
            is_read: false,
        }
        let response = await api.get(url, params);
        this.setState(
            {
                notifications: response.data.results,
            }
        );
    }

    async retrieveMessageCount(){
        const api = new BaseApi();
        let url = 'opportunity/unread_comments/';
        let response = await api.get(
            url,
            {}
        );
        let unreadComments = response.data;
        this.setState({
            unreadComments: unreadComments,
        });
    }

    async retrieveOpportunities() {
        this.setState({
            opportunities: null,
        });
        let url = 'opportunity/report/';
        let params = {
            status: 'OPENX',
            group: true,
            featured: false,
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        let opportunities = response.data.report;
        params.featured = true;
        params.group = false;
        response = await api.get(
            url,
            params
        );
        let opportunitiesFeatured = response.data.report
        delete params.featured
        params.work_started = true
        params.work_ended = false
        response = await api.get(
            url,
            params
        );
        let opportunitiesWorkStarted = response.data.report
        this.setState({
            opportunities: opportunities,
            opportunitiesFeatured: opportunitiesFeatured,
            opportunitiesWorkStarted: opportunitiesWorkStarted,
        });
    }

    render() {
        if (!this.state.opportunities || !this.state.opportunitiesFeatured || !this.state.opportunitiesWorkStarted || !this.state.deliveryStates || !this.state.routeStates || !this.state.notifications){
            return (
                <CircularProgress />
            )
        }
        let totalCount = 0;
        if (this.state.unreadComments){
            for (const v of Object.values(this.state.unreadComments)){
                totalCount += v
            }
        }
        return(
            <Sheet
                variant="plain"
                color="neutral"
                sx={
                    {
                        height: '100%',
                        alignContent: 'space-between',
                        display: 'flex',
                        flexWrap: 'wrap',
                        borderRadius: 'md',
                    }
                }
            >
                <Grid
                    container={true}
                    sx={{
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <Grid
                        md={3}
                        sx={{
                            height: '100%',
                        }}
                    >
                        <Stack
                            sx={{
                                height: '100%',
                            }}
                            spacing={1}
                        >
                            <Card
                                variant={'soft'}
                                size={'sm'}
                            >
                                <Card
                                    size={'sm'}
                                    variant={this.state.mode==='Notification'?'soft':'outlined'}
                                    color={!this.state.notifications.length?'primary':'warning'}
                                    orientation="horizontal"
                                    onClick={() => {
                                        this.setMode('Notification')
                                    }}
                                    sx={{
                                        cursor: 'pointer'
                                    }}
                                >
                                    Уведомления
                                    <Chip
                                        color={!this.state.notifications.length?'primary':'warning'}
                                    >
                                        {this.state.notifications.length}
                                    </Chip>
                                </Card>
                                <Card
                                    size={'sm'}
                                    variant={this.state.mode==='DeliveryState'?'soft':'outlined'}
                                    color={!this.state.deliveryStates.length?'primary':'warning'}
                                    orientation="horizontal"
                                    onClick={() => {
                                        this.setMode('DeliveryState')
                                    }}
                                    sx={{
                                        cursor: 'pointer'
                                    }}
                                >
                                    Бизнес процессы
                                    <Chip
                                        color={!this.state.deliveryStates.length?'primary':'warning'}
                                    >
                                        {this.state.deliveryStates.length}
                                    </Chip>
                                </Card>
                                <Card
                                    size={'sm'}
                                    variant={this.state.mode==='RouteState'?'soft':'outlined'}
                                    color={!this.state.routeStates.length?'primary':'warning'}
                                    orientation="horizontal"
                                    onClick={() => {
                                        this.setMode('RouteState')
                                    }}
                                    sx={{
                                        cursor: 'pointer'
                                    }}
                                >
                                    Маршруты
                                    <Chip
                                        color={!this.state.routeStates.length?'primary':'warning'}
                                    >
                                        {this.state.routeStates.length}
                                    </Chip>
                                </Card>
                                {
                                    this.state.leadPermission && this.state.leads?

                                        <Card
                                            size={'sm'}
                                            variant={this.state.mode==='Lead'?'soft':'outlined'}
                                            color={!this.state.leads.length?'primary':'warning'}
                                            orientation="horizontal"
                                            onClick={() => {
                                                this.setMode('Lead')
                                            }}
                                            sx={{
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Входящие лиды
                                            <Chip
                                                color={!this.state.leads.length?'primary':'warning'}
                                            >
                                                {this.state.leads.length}
                                            </Chip>
                                        </Card>:null
                                }
                            </Card>
                            <Card
                                size={'sm'}
                                variant={'soft'}
                                sx={{
                                    height: '90%',
                                    overflowY: 'scroll',
                                    flexGrow: 10
                                }}
                            >
                                <Card
                                    size={'sm'}
                                    variant={"outlined"}
                                    color={!totalCount?'neutral':'warning'}
                                    orientation="horizontal"
                                >
                                    Комментариев не прочитано:
                                    <Chip
                                        color={!totalCount?'primary':'warning'}
                                    >
                                        {totalCount}
                                    </Chip>
                                </Card>
                                <AccordionGroup>
                                    <Accordion>
                                        <AccordionSummary
                                            variant="soft"
                                            slotProps={{
                                                button: {
                                                    sx: {
                                                        backgroundColor: '#CC3300',
                                                        backgroundImage: 'linear-gradient(45deg, #990000 25%, transparent 25%, transparent 50%, #990000 50%, #990000 75%, transparent 75%, transparent)',
                                                        backgroundSize: '50px 50px',
                                                    }
                                                }
                                            }}
                                        >
                                            <Stack
                                                direction={'row'}
                                                spacing={2}
                                                sx={{
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: 'white'
                                                    }}
                                                >
                                                     Избранное
                                                </Typography>
                                                {
                                                    this.state.unreadComments?
                                                        <Chip
                                                            sx={{
                                                                height: '100%',
                                                            }}
                                                        >
                                                            {(()=>{
                                                                let count = 0;
                                                                for (const o of this.state.opportunitiesFeatured){
                                                                    if (o[0] in this.state.unreadComments){
                                                                        count += this.state.unreadComments[o[0]]
                                                                    }
                                                                }
                                                                return count
                                                            })()}
                                                        </Chip>:
                                                        null
                                                }
                                            </Stack>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            sx={{
                                                [`& .${accordionDetailsClasses.content}`]: {
                                                    p: 0
                                                }
                                            }}
                                        >
                                            <Stack
                                                sx={{
                                                    mt: 1,
                                                    mb: 1
                                                }}
                                                spacing={1}
                                            >
                                                {
                                                    this.state.opportunitiesFeatured.map((o) => (
                                                        <OpportunityCard
                                                            color={o[2]}
                                                            mini={true}
                                                            opportunityID={o[0]}
                                                            selected={o[0]===this.state.opportunity?.id}
                                                            callBack={this.setOpportunity.bind(this)}
                                                            showDeliveryStates={true}
                                                            extraModules={[
                                                                <CommonCallBackButton
                                                                    variant={'solid'}
                                                                    icon={StarIcon}
                                                                    color={'warning'}
                                                                    callBack={this.feature.bind(this, o[0])}
                                                                />,
                                                                <Chip
                                                                    color={
                                                                        this.state.unreadComments&&this.state.unreadComments[o[0]]?'warning':'neutral'
                                                                    }
                                                                    sx={{
                                                                        height: '100%',
                                                                    }}
                                                                >
                                                                    {this.state.unreadComments?this.state.unreadComments[o[0]]:0}
                                                                </Chip>
                                                            ]}
                                                        />
                                                    ))
                                                }
                                            </Stack>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            variant="soft"
                                            slotProps={{
                                                button: {
                                                    sx: {
                                                        backgroundColor: 'green',
                                                        backgroundImage: 'linear-gradient(45deg, darkGreen 25%, transparent 25%, transparent 50%, darkGreen 50%, darkGreen 75%, transparent 75%, transparent)',
                                                        backgroundSize: '50px 50px',
                                                    }
                                                }
                                            }}
                                        >
                                            <Stack
                                                direction={'row'}
                                                spacing={2}
                                                sx={{
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: 'white'
                                                    }}
                                                >
                                                     Идут работы
                                                </Typography>
                                                {
                                                    this.state.unreadComments?
                                                        <Chip
                                                            sx={{
                                                                height: '100%',
                                                            }}
                                                        >
                                                            {(()=>{
                                                                let count = 0;
                                                                for (const o of this.state.opportunitiesWorkStarted){
                                                                    if (o[0] in this.state.unreadComments){
                                                                        count += this.state.unreadComments[o[0]]
                                                                    }
                                                                }
                                                                return count
                                                            })()}
                                                        </Chip>:
                                                        null
                                                }
                                            </Stack>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            sx={{
                                                [`& .${accordionDetailsClasses.content}`]: {
                                                    p: 0
                                                }
                                            }}
                                        >
                                            <Stack
                                                sx={{
                                                    mt: 1,
                                                    mb: 1
                                                }}
                                                spacing={1}
                                            >
                                                {
                                                    this.state.opportunitiesWorkStarted.map((o) => (
                                                        <OpportunityCard
                                                            color={o[2]}
                                                            mini={true}
                                                            opportunityID={o[0]}
                                                            selected={o[0]===this.state.opportunity?.id}
                                                            callBack={this.setOpportunity.bind(this)}
                                                            showDeliveryStates={true}
                                                            extraModules={[
                                                                <CommonCallBackButton
                                                                    variant={'solid'}
                                                                    icon={StarIcon}
                                                                    color={'warning'}
                                                                    callBack={this.feature.bind(this, o[0])}
                                                                />,
                                                                <Chip
                                                                    color={
                                                                        this.state.unreadComments&&this.state.unreadComments[o[0]]?'warning':'neutral'
                                                                    }
                                                                    sx={{
                                                                        height: '100%',
                                                                    }}
                                                                >
                                                                    {this.state.unreadComments?this.state.unreadComments[o[0]]:0}
                                                                </Chip>
                                                            ]}
                                                        />
                                                    ))
                                                }
                                            </Stack>
                                        </AccordionDetails>
                                    </Accordion>
                                    {
                                        this.state.opportunities.map((t) => (
                                            <Accordion>
                                                <AccordionSummary
                                                    color={t.color}
                                                    variant="soft"
                                                >
                                                    <Stack
                                                        direction={'row'}
                                                        spacing={2}
                                                        sx={{
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <Typography
                                                            color={'light'}
                                                        >
                                                             {t.title}
                                                        </Typography>
                                                        {
                                                            this.state.unreadComments?
                                                                <Chip
                                                                    sx={{
                                                                        height: '100%',
                                                                    }}
                                                                >
                                                                    {(()=>{
                                                                        let count = 0;
                                                                        for (const o of t.opportunities){
                                                                            if (o[0] in this.state.unreadComments){
                                                                                count += this.state.unreadComments[o[0]]
                                                                            }
                                                                        }
                                                                        return count
                                                                    })()}
                                                                </Chip>:
                                                                null
                                                        }
                                                    </Stack>
                                                </AccordionSummary>
                                                <AccordionDetails
                                                    sx={{
                                                        [`& .${accordionDetailsClasses.content}`]: {
                                                            p: 0
                                                        }
                                                    }}
                                                >
                                                    <Stack
                                                        sx={{
                                                            mt: 1,
                                                            mb: 1
                                                        }}
                                                        spacing={1}
                                                    >
                                                        {
                                                            t.opportunities.map((o) => (
                                                                <RenderIfVisible
                                                                    defaultHeight={50}
                                                                    stayRendered={true}
                                                                    key={o.id}
                                                                >
                                                                    <OpportunityCard
                                                                        showDeliveryStates={true}
                                                                        color={o[2]}
                                                                        mini={true}
                                                                        mlPermission={this.state.mlPermission}
                                                                        selected={o[0]===this.state.opportunity?.id}
                                                                        opportunityID={o[0]}
                                                                        callBack={this.setOpportunity.bind(this)}
                                                                        extraModules={[
                                                                            <CommonCallBackButton
                                                                                variant={'outlined'}
                                                                                icon={StarIcon}
                                                                                color={'neutral'}
                                                                                callBack={this.feature.bind(this, o[0])}
                                                                            />,
                                                                            <Chip
                                                                                color={
                                                                                    this.state.unreadComments&&this.state.unreadComments[o[0]]?'warning':'neutral'
                                                                                }
                                                                                sx={{
                                                                                    height: '100%',
                                                                                }}
                                                                            >
                                                                                {this.state.unreadComments?this.state.unreadComments[o[0]]:0}
                                                                            </Chip>
                                                                        ]}
                                                                    />
                                                                </RenderIfVisible>
                                                            ))
                                                        }
                                                    </Stack>
                                                </AccordionDetails>
                                            </Accordion>
                                        ))
                                    }
                                </AccordionGroup>
                            </Card>
                        </Stack>

                    </Grid>
                    <Grid
                        md={9}
                        sx={{
                            height: '100%',
                            pl: 2
                        }}
                    >
                        <Stack
                            sx={{
                                height: '100%',
                            }}
                        >
                            {
                                this.state.opportunity && this.state.mode === 'Opportunity'?
                                    <>
                                        <Card
                                            size={'sm'}
                                            orientation="horizontal"
                                            sx={{
                                                height: '15%',
                                                mb: 2
                                            }}
                                            variant={'soft'}
                                        >
                                            <CardOverflow
                                                variant='soft'
                                                color={this.state.opportunityColor}
                                                sx={{
                                                    px: 0.5,
                                                    writingMode: 'vertical-rl',
                                                    textAlign: 'center',
                                                    fontSize: 'xs',
                                                    fontWeight: 'xl',
                                                    letterSpacing: '1px',
                                                    textTransform: 'uppercase',
                                                    borderLeft: '1px solid',
                                                    borderColor: 'divider',
                                                }}
                                            >

                                            </CardOverflow>
                                            <CardContent
                                                sx={{
                                                    height: '100%',
                                                }}
                                            >
                                                <Stack
                                                    direction={'row'}
                                                    sx={{
                                                        justifyContent: "space-between",
                                                        alignItems: "top",
                                                        overflowY: 'hidden',
                                                        height: '100%'
                                                    }}
                                                >
                                                    <Stack
                                                        spacing={1}
                                                        sx={{
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <OpportunityCard
                                                            opportunity={this.state.opportunity}
                                                            nano={true}
                                                            key={'OpportunityCard'+this.state.opportunity.id+'nano'}
                                                        />
                                                        <AccountCard
                                                            account={this.state.opportunity.account}
                                                            mini={true}
                                                            key={'AccountCard'+this.state.opportunity.account.id}
                                                        />
                                                        <CommentReadAll
                                                            appId={this.state.opportunity.id}
                                                            appName={'Opportunity'}
                                                            key={'CommentReadAll'+this.state.opportunity.id}
                                                        />
                                                    </Stack>
                                                    <Stack
                                                        spacing={1}
                                                        sx={{
                                                            overflowY: 'scroll',
                                                            height: '100%',
                                                            width: '70%',
                                                        }}
                                                    >
                                                        {
                                                            this.state.opportunityDeliveryStates.filter((e) => (e.operator.id === this.context.subscriberObject.id)).map((s) => {
                                                                return (
                                                                    <ComponentCard
                                                                        key={'DeliveryCard'+s.id}
                                                                        entity={'DeliveryState'}
                                                                        entity_id={s.id}
                                                                    />
                                                                )
                                                            })
                                                        }
                                                    </Stack>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                        <Card
                                            sx={{
                                                height: '85%'
                                            }}
                                            size={'sm'}
                                        >
                                            <CommentSidebar
                                                appName={'Opportunity'}
                                                appId={this.state.opportunity.id}
                                                reverse={true}
                                                key={'CommentSidebarOpportunity' + this.state.opportunity.id}
                                            />
                                        </Card>
                                    </>:
                                    <></>
                            }
                            {
                                 this.state.mode === 'DeliveryState'?
                                     <Card
                                        variant={'outlined'}
                                        sx={{
                                            height: '100%',
                                            overflowY: 'scroll'
                                        }}
                                     >
                                        <DeliveryTable
                                            showTitle={true}
                                            deliveries={this.state.deliveryStates}
                                            showAccount={true}
                                            showOpportunity={true}
                                            callBack={this.retrieveDeliveryStates.bind(this)}
                                        />
                                     </Card>:<></>
                            }
                            {
                                 this.state.mode === 'RouteState'?
                                     <Card
                                        variant={'outlined'}
                                        sx={{
                                            height: '100%',
                                            overflowY: 'scroll'
                                        }}
                                     >
                                        <RouteTable
                                            showTitle={true}
                                            routes={this.state.routeStates}
                                            callBack={this.retrieveRouteStates.bind(this)}
                                        />
                                     </Card>:<></>
                            }

                            {
                                 this.state.mode === 'Notification'?
                                     <Card
                                        variant={'outlined'}
                                        sx={{
                                            height: '100%',
                                            overflowY: 'scroll'
                                        }}
                                     >
                                        <CommonPaginatedTable
                                            title={'Уведомления'}
                                            data={this.state.notifications}
                                            extraComponents={[
                                                {
                                                    component: CommonCallBackButton,
                                                    componentProps: {
                                                        propsObject: 'componentObj',
                                                        propsObjectKey: 'id',
                                                        label: 'Прочитать все',
                                                        icon: VisibilityIcon,
                                                        color: 'neutral',
                                                    },
                                                    callBack: this.notificationsReadAll.bind(this)
                                                }
                                            ]}
                                            fields={[
                                                {
                                                    title: '',
                                                    name: 'title',
                                                    visible: true,
                                                    width: '70%',
                                                },
                                                {
                                                    title: '',
                                                    visible: true,
                                                    component: NotificationDetailModal,
                                                    componentProps: {
                                                        setRead: false,
                                                    },
                                                    callBack: this.retrieveNotifications.bind(this)
                                                },
                                                {
                                                    title: 'Создано',
                                                    name: 'created_on',
                                                    visible: true,
                                                },
                                            ]
                                            }
                                        />
                                     </Card>:<></>
                            }
                            {
                                 this.state.mode === 'Lead' && this.state.leadPermission && this.state.leads?
                                     <Card
                                        variant={'outlined'}
                                        sx={{
                                            height: '100%',
                                            overflowY: 'scroll'
                                        }}
                                     >
                                         <CommonPaginatedTable
                                            title={'Входящие лиды'}
                                            url={'lead/incoming'}
                                            data={this.state.leads}
                                            fields={[
                                                {
                                                    title: 'Тема',
                                                    name: 'title',
                                                    visible: true,
                                                    linkPattern: '/lead/detail/:linkParam',
                                                    linkParam: 'id',
                                                    linkTarget: '_blank',
                                                },
                                                {
                                                    title: 'Компания',
                                                    name: 'account_title',
                                                    visible: true,
                                                },
                                                {
                                                    title: 'Источник',
                                                    name: 'source.title',
                                                    chip: true,
                                                    color_rule: (value, comparison) => ('primary'),
                                                    visible: true,
                                                },
                                                {
                                                    title: 'Статус',
                                                    name: 'status_human',
                                                    chip: true,
                                                    color_rule: (value, comparison) => {
                                                        switch (value){
                                                            case 'OPEN':
                                                                return 'warning'
                                                            case 'CLOSE':
                                                                return 'success'
                                                            case 'LOST':
                                                                return 'danger'
                                                            default:
                                                                return 'primary'
                                                        }
                                                    },
                                                    color_value: 'status',
                                                    visible: true,
                                                },
                                                {
                                                    title: 'Компания CRM',
                                                    name: 'account.nameshort',
                                                    visible: true,
                                                    linkPattern: '/account/detail/:linkParam',
                                                    linkParam: 'account.id',
                                                },
                                                {
                                                    title: 'Сделка',
                                                    name: 'opportunity.short_name',
                                                    visible: true,
                                                    linkPattern: '/opportunity/detail/:linkParam',
                                                    linkParam: 'opportunity.id',
                                                },
                                                {
                                                    title: 'Создано',
                                                    name: 'created_on',
                                                    visible: true,
                                                },
                                                {
                                                    title: 'Обновлено',
                                                    name: 'updated_on',
                                                    visible: true,
                                                },
                                            ]
                                            }
                                        />
                                     </Card>:<></>
                            }
                        </Stack>
                    </Grid>
                </Grid>
            </Sheet>
        )
    }
}

export default OpportunityCommentCenter